import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  TextField,
  Box,
  MenuItem,
  Chip,
  InputLabel,
  Select,
  OutlinedInput,
  FormControl,
  Typography,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  InputAdornment,
  IconButton,
  Autocomplete,
  styled,
  Radio,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import PlacesAutocomplete from "react-places-autocomplete";
import "./style.css";
import {
  combineAndFlattenArrays,
  convertToGMT,
  convertToUTC,
  extractSuggestionProps,
  getDateDifference,
  getMinDateTime,
  handleRedirectUrl,
  roundToNext5Minutes,
} from "../../utils/Functions";
import moment from "moment";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../loader";
import {
  getCars,
  getCategoryByData,
  getCategoryStopOvers,
  postSaveCategory,
  postUpdateCategory,
  getCategoryTags,
} from "../../utils/api.functions";
import { toast } from "react-toastify";
import citiesJson from "../../utils/cities";
import { defaultValues, delayData } from "../../utils/common.data";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const stepValidationSchemas = [
  // Step 0: General Info
  Yup.object({
    cat_name: Yup.string().trim().required("This field is Required"),
    start_location: Yup.string().trim().required("This field is Required"),
    end_location: Yup.string()
      .trim()
      .required("This field is Required")
      .test(
        "different-from-start",
        "End location cannot be the same as start location",
        function (value) {
          const { start_location } = this.parent;
          return value !== start_location;
        }
      ),
    pickup: Yup.string().trim().required("This field is Required"),
    drop: Yup.string().trim().required("This field is Required"),
    stops: Yup.array(),
  }),
  // Step 1: Select Stops
  // Yup.object({
  //   stops: Yup.array(),
  // }),
  // Step 2: Select Departure Date
  Yup.object({
    departure_date: Yup.string().required("This field is Required"),
    arrival_date: Yup.string().required("This field is Required"),
    cat_max_size: Yup.number().required("This field is Required").min(1),
    cat_base_price: Yup.number().required("This field is Required").min(1),
    car_id: Yup.string().required("This field is Required"),
  }),
  // Step 3: Select Seat
  // Yup.object({
  //   cat_max_size: Yup.number().required("This field is Required").min(1),
  //   cat_base_price: Yup.number().required("This field is Required").min(1),
  // }),
  // Step 4: Select Price
  // Yup.object({
  //   cat_base_price: Yup.number().required("This field is Required").min(1),
  // }),
  // Step 4: Vehicle Info
  // Yup.object({
  //   car_id: Yup.string().required("This field is Required"),
  // }),
];

const validationSchema = Yup.object({
  cat_name: Yup.string().trim().required("This field is Required"),
  start_location: Yup.string().trim().required("This field is Required"),
  end_location: Yup.string().trim().required("This field is Required"),
  pickup: Yup.string().trim().required("This field is Required"),
  drop: Yup.string().trim().required("This field is Required"),
  departure_date: Yup.string().required("This field is Required"),
  arrival_date: Yup.string().required("This field is Required"),
  car_id: Yup.string().required("This field is Required"),
  cat_max_size: Yup.number().required("This field is Required").min(1),
  cat_base_price: Yup.number().required("This field is Required").min(1),
  stops: Yup.array(),
});

const PostRideForm = ({ handleBack }) => {
  const [formView, setFormView] = useState(0);
  const [pickupLatLng, setPickupLatLng] = useState(null);
  const [dropLatLng, setDropLatLng] = useState(null);
  const [pickupCity, setPickupCity] = useState(null);
  const [dropCity, setDropCity] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cars, setCars] = useState([]);
  const [categoryTags, setCategoryTags] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [directions, setDirections] = useState(null);
    const [distance, setDistance] = useState(0);
    const [duration, setDuration] = useState(1);
  const params = useParams();

  const initialFormValues = useMemo(
    () => ({
      cat_name: "",
      start_location: "",
      end_location: "",
      start_location_title: "",
      end_location_title: "",
      start_location_descp: "",
      end_location_descp: "",
      pickup: "",
      drop: "",
      departure_date: roundToNext5Minutes(dayjs().add(1, "hour")),
      arrival_date: roundToNext5Minutes(dayjs().add(2, "hour")),
      cat_max_size: "1",
      cat_base_price: "200",
      car_id: "",
      stops: [],
      boarding_points: [],
      dropping_points: [],
    }),
    []
  );

  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: stepValidationSchemas[formView],
    enableReinitialize: true,
    onSubmit: (values) => {
      const payload = {
        ...values,
        stops: selectedItems,
        tags: tags,
      };
      // console.log("Form submitted:", payload);
      const Value = getDateDifference(
        payload.departure_date.$d,
        payload.arrival_date.$d
      );
      // console.log({ Value })

      const createData = {
        ...payload,
        boarding_points: JSON.stringify([
          {
            title: pickupCity || payload.start_location_title,
            descp: payload.pickup,
            address: payload.pickup,
            lat: pickupLatLng?.lat,
            lng: pickupLatLng?.lng,
          },
        ]),
        dropping_points: JSON.stringify([
          {
            title: dropCity || payload.end_location_title,
            descp: payload.drop,
            address: payload.drop,
            lat: dropLatLng?.lat,
            lng: dropLatLng?.lng,
          },
        ]),
        arr_hrs: Value,
        arrival_date: moment(convertToGMT(payload.arrival_date))
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DD HH:mm:ss"),
        departure_date: moment(convertToGMT(payload.departure_date))
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DD HH:mm:ss"),
        cat_special_fare: JSON.stringify({
          window: payload.cat_base_price,
          normal: payload.cat_base_price,
        }),
        cat_special_fare_json: JSON.stringify({
          window: payload.cat_base_price,
          normal: payload.cat_base_price,
        }),
        cat_stopover: JSON.stringify(selectedItems?.map((value)=> value?.trim())),
        cat_tags: JSON.stringify(tags?.map((value)=> value?.trim())),
        boarding_data: {
            title: pickupCity || payload.start_location_title,
            descp: payload.pickup,
            address: payload.pickup,
            lat: pickupLatLng?.lat,
            lng: pickupLatLng?.lng,
          },
        dropping_data: {
            title: dropCity || payload.end_location_title,
            descp: payload.drop,
            address: payload.drop,
            lat: dropLatLng?.lat,
            lng: dropLatLng?.lng,
          },
        stops_route:directions,
        dist_fr_json: distance,
      };
      if (createData?.pickup) {
        delete createData.pickup;
      }
      if (createData?.drop) {
        delete createData.drop;
      }
      if (createData?.tags) {
        delete createData.tags;
      }
      if (createData?.start_location_title) {
        delete createData.start_location_title;
      }
      if (createData?.end_location_title) {
        delete createData.end_location_title;
      }
      if (createData?.start_location_descp) {
        delete createData.start_location_descp;
      }
      if (createData?.end_location_descp) {
        delete createData.end_location_descp;
      }
      if (payload?.stops?.length == 0 || payload?.stops?.length > 0) {
        delete createData.stops;
      }
      if (payload?.stops?.length == 0) {
        delete createData.cat_stopover;
      }
      if (tags?.length == 0) {
        delete createData.cat_tags;
      }
      if(!createData?.stops_route){
        delete createData.stops_route;
      }
      if(!createData?.dist_fr_json){
        delete createData.dist_fr_json;
      }

     console.log({ createData });

      if (params?.id) {
        handleUpdate(params?.id, createData);
      } else {
        handleCreate(createData);
      }
    },
  });

  // Auto-fill cat_name when both locations are filled
  useEffect(() => {
    const { start_location, end_location } = formik.values;
    if (start_location && end_location) {
      formik.setFieldValue("cat_name", `${start_location} To ${end_location}`);
    }
  }, [formik.values.start_location, formik.values.end_location]);

  const handlePlaceSelect = async (value, placeId, fieldName) => {
    // console.log({ value, placeId })
    // const results = await geocodeByAddress(value);
    // const latLng = await getLatLng(results[0]);
    // console.log({results})

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=AIzaSyDPpZr1xE7UHb9ydlYXgBr1D3zB4vXyTSY`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.results && data.results[0].geometry) {
          const { lat, lng } = data.results[0].geometry.location;
          const l3 = { lat: lat, lng: lng };

          // Get address components from the first result
          const addressComponents = data.results[0].address_components;

          // Find the city/locality from address components
          const city = addressComponents.find((component) =>
            component.types.includes("locality")
          )?.long_name;

          // Or as a fallback, look for administrative area level
          const fallbackCity = addressComponents.find((component) =>
            component.types.includes("administrative_area_level_1")
          )?.long_name;

          const mainCity = city || fallbackCity || "";

          formik.setFieldValue(fieldName, value);
          if (fieldName === "start_location_title") {
            setPickupLatLng(l3);
            setPickupCity(mainCity);
            formik.setFieldValue("pickup", value);
            formik.setFieldValue("start_location_descp", value);
          }
          if (fieldName === "end_location_title") {
            formik.setFieldValue("drop", value);
            formik.setFieldValue("end_location_descp", value);
            setDropLatLng(l3);
            setDropCity(mainCity);
          }
        } else {
          console.error("No geometry data found:", data);
        }
      })
      .catch((error) => console.error("Error fetching place details:", error));
  };

  useEffect(() => {
     if(pickupLatLng && dropLatLng) {
        if (!window.google) return;
  
      const directionsService = new window.google.maps.DirectionsService();
  
      directionsService.route(
        {
          origin: pickupLatLng,
          destination: dropLatLng,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === 'OK' && result) {
              ////console.log(`All Result`,JSON.stringify(result)); // Log the entire result for debugging
              ////console.log(`Polyline`, JSON.stringify(result.routes[0].overview_polyline)); // Log the first leg of the route
              let route = result.routes[0].legs[0];
              let distance = route.distance.value / 1000; // Convert meters to km
              let time = Math.ceil(route.duration.value / 60); // Convert seconds to minutes
              let polyline = result.routes[0].overview_polyline;
              setDirections(polyline);
              setDistance(distance);
              setDuration(time);
              formik.setFieldValue("arrival_date", roundToNext5Minutes(dayjs(formik.values.departure_date).add(time, "minutes")));
              ////console.log(`Distance: ${distance} km, Duration: ${time} minutes, Polyline: ${polyline}`);
          } else {
            console.error('Directions request failed due to', status);
          }
        }
      );
     }
    }, [pickupLatLng,dropLatLng]);

  // useEffect(() => {
  //   getCategoryData();
  //   getCarsList();
  //   getCategoryTagsList();
  // }, []);

  useEffect(() => {
    // console.log({ start:formik.values.start_location, end:formik.values.end_location });
    getCategoryStopsData(formik.values.start_location, formik.values.end_location);
  }, [formik.values.end_location, formik.values.start_location]);

  // Params Data

  const location = useLocation();

  useEffect(() => {
    const mainValue = new URLSearchParams(location.search);
    // console.log({mainValue},location.search)
    const value = mainValue.get("params");
    const valueRide = mainValue.get("ridePost");
    // console.log({valueRide})
    if (value) {
      try {
        const testdata = JSON.parse(value);
        // console.log({testdata})
        sessionStorage.setItem("key", testdata?.key);
        sessionStorage.setItem("code", testdata?.c_code);
        sessionStorage.setItem(
          "phone",
          "+" + testdata?.c_code + "" + testdata?.phone
        );
        sessionStorage.setItem("userid", testdata?.userid);
        sessionStorage.setItem("company_id", testdata?.comp_id);
        sessionStorage.setItem("fname", testdata?.fname);
        sessionStorage.setItem("lname", testdata?.lname);
        sessionStorage.setItem("email", testdata?.email);
        sessionStorage.setItem("name", testdata?.name);
        sessionStorage.setItem("city_id", testdata?.city_id);
        sessionStorage.setItem("city_cur", testdata?.city_cur);
        sessionStorage.setItem("auth", JSON.stringify(testdata));

        getCategoryData();
        getCarsList();
        getCategoryTagsList();
      } catch (error) {
        console.log(`User Params Data`, error?.message);
        handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
      }
    } else {
      handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
    }

    if (valueRide) {
      try {
        const valueRideData = JSON.parse(valueRide);
        if (valueRideData) {
          console.log({valueRideData})
          formik.setFieldValue("start_location", valueRideData?.from_location);
          formik.setFieldValue("end_location", valueRideData?.to_location);
          formik.setFieldValue("cat_max_size", valueRideData?.seats);
          formik.setFieldValue(
            "departure_date",
            dayjs(convertToUTC(valueRideData?.departure_date))
          );
          formik.setFieldValue(
            "arrival_date",
            dayjs(convertToUTC(valueRideData?.departure_date)).add(1, "hour")
          );
        }
      } catch (error) {
        console.log(`RidePost Params Data`, error?.message);
      }
    }
  }, []);

  // Stops
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [tags, setTags] = useState([]);
  const [newItem, setNewItem] = useState("");
  const [error, setError] = useState("");

  const handleAddItem = () => {
    const trimmed = newItem.trim();

    if (!trimmed) {
      setError("Stops cannot be empty.");
      return;
    }

    const duplicate = items.some(
      (item) => item.toLowerCase() === trimmed.toLowerCase()
    );
    if (duplicate) {
      setError("Stops already exists in the list.");
      return;
    }

    setItems([...items, trimmed]);
    handleToggle(trimmed);
    setNewItem("");
    setError("");
    document.getElementById("post_ride_stop_input").focus()
  };

  const handleToggle = (item) => {
    const isSelected = selectedItems.includes(item);
    const updatedSelection = isSelected
      ? selectedItems.filter((i) => i !== item)
      : [...selectedItems, item];

    setSelectedItems(updatedSelection);
  };

  const handleDeleteChip = (itemToDelete) => {
    setSelectedItems((prev) => prev.filter((item) => item !== itemToDelete));
  };

  const handleCarToggle = (item) => {
    formik.setFieldValue("car_id", formik.values.car_id == item ? "" : item);
  };

  const handleDeleteCarChip = (item) => {
    formik.setFieldValue("car_id", item);
  };

  const handleTagsToggle = (item) => {
    const isSelected = tags.includes(item);
    const updatedSelection = isSelected
      ? tags.filter((i) => i !== item)
      : [...tags, item];

    setTags(updatedSelection);
  };

  const handleDeleteTags = (itemToDelete) => {
    setTags((prev) => prev.filter((item) => item !== itemToDelete));
  };

  const handleTagView = (tagData, categoryTags) => {
    return categoryTags.filter((value) => tagData.includes(value.value));
  };

  const handleChange = (e) => {
    setNewItem(e.target.value);
    setError("");
  };

  const handleCreate = async (data) => {
    setIsLoading(true);
    let apikey = sessionStorage.getItem("key");
    const userid = sessionStorage.getItem("userid");
    const city_id = sessionStorage.getItem("city_id");
    try {
      const categoryData = {
        ...data,
        driver_id: userid,
        city_id: city_id,
      };

      const categoryReponse = await postSaveCategory(categoryData, apikey);
      if (categoryReponse.status == 200) {
        toast.success("Ride Created Successfully");
        setIsLoading(false);
        sessionStorage.removeItem("searchdetails");
        // setTimeout(() => {
        //   handleRedirectUrl(
        //     `${
        //       process.env.REACT_APP_TRIP_SUCCESS_API
        //     }?requestData=${JSON.stringify(
        //       categoryReponse.data.resDecrypt.response
        //     )}`,
        //     "_self"
        //   );
        // }, delayData.androidFormDelay);
        handleRedirectUrl(
          `${
            process.env.REACT_APP_TRIP_SUCCESS_API
          }?requestData=${JSON.stringify(
            categoryReponse.data.resDecrypt.response
          )}`,
          "_self"
        );
      }
    } catch (error) {
      toast.dismiss();
      console.log(`Category  Error`, error);
      toast.error(
        error?.response?.data?.resDecrypt?.message ||
          error?.message ||
          "Something Went Wrong?"
      );
      setIsLoading(false);
      // setTimeout(() => {
      //   handleRedirectUrl(
      //     `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
      //     "_self"
      //   );
      // }, delayData.androidFormDelay);
    }
  };

  const handleUpdate = async (id, data) => {
    setIsLoading(true);
    let apikey = sessionStorage.getItem("key");
    // const userid = sessionStorage.getItem("userid");
    try {
      const categoryData = {
        ...data,
        category_id: id,
      };
      // console.log(categoryData);

      const categoryReponse = await postUpdateCategory(categoryData, apikey);
      if (categoryReponse.status == 200) {
        toast.success("Ride Updated Successfully");
        setIsLoading(false);
        sessionStorage.removeItem("searchdetails");
        // if (handleBack) {
        //   handleBack();
        //   return
        // }
        handleRedirectUrl(
          `${
            process.env.REACT_APP_TRIP_SUCCESS_API
          }?requestData=${JSON.stringify(
            categoryReponse?.data?.resDecrypt?.response
          )}`,
          "_self"
        );
      }
    } catch (error) {
      toast.dismiss();
      console.log(`Category  Error`, error);
      toast.error(
        error?.response?.data?.resDecrypt?.message ||
          error?.message ||
          "Something Went Wrong?"
      );
      setIsLoading(false);
      // handleRedirectUrl(
      //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
      //   "_self"
      // );
    }
  };

  const getCategoryData = async () => {
    if (params?.id) {
      setIsLoading(true);
      let apikey = sessionStorage.getItem("key");
      // const userid = sessionStorage.getItem("userid");
      const city_id = sessionStorage.getItem("city_id");
      try {
        const response = await getCategoryByData(
          { category_id: params?.id, city_id: city_id },
          apikey
        );
        ////console.log({ response });

        if (response.status === 200) {
          const newData = response?.data?.resDecrypt?.response;

          if (newData && newData.length > 0) {
            setCategoryData(newData);
            const boardingPoints = newData[0]?.boarding_points;
            const droppingPoints = newData[0]?.dropping_points;
            setSelectedItems(newData[0]?.stops);
            setTags(newData[0]?.cat_tags);
            formik.setFieldValue("cat_name", newData[0]?.cat_name);
            formik.setFieldValue("start_location", newData[0]?.start_location);
            formik.setFieldValue("end_location", newData[0]?.end_location);
            formik.setFieldValue("cat_max_size", newData[0]?.cat_max_size);
            formik.setFieldValue("cat_base_price", newData[0]?.cat_base_price);
            formik.setFieldValue("cat_stopover", newData[0]?.cat_stopover);
            formik.setFieldValue("cat_tags", newData[0]?.cat_tags);
            formik.setFieldValue(
              "car_id",
              newData[0]?.car ? newData[0]?.car?.car_id : ""
            );
            formik.setFieldValue(
              "arrival_date",
              moment(convertToUTC(newData[0]?.arrival_date)).format(
                "YYYY-MM-DDTHH:mm"
              )
            );
            formik.setFieldValue(
              "departure_date",
              moment(convertToUTC(newData[0]?.departure_date)).format(
                "YYYY-MM-DDTHH:mm"
              )
            );
            if (Array.isArray(boardingPoints) && boardingPoints.length > 0) {
              formik.setFieldValue("pickup", boardingPoints[0]?.descp);
              formik.setFieldValue(
                "start_location_title",
                boardingPoints[0]?.title
              );
              formik.setFieldValue(
                "start_location_descp",
                boardingPoints[0]?.descp
              );
              setPickupLatLng({
                lat: boardingPoints[0]?.lat,
                lng: boardingPoints[0]?.lng,
              });
              setPickupCity(boardingPoints[0]?.title);
            }
            if (Array.isArray(droppingPoints) && droppingPoints.length > 0) {
              formik.setFieldValue("drop", droppingPoints[0]?.descp);
              formik.setFieldValue(
                "end_location_title",
                droppingPoints[0]?.title
              );
              formik.setFieldValue(
                "end_location_descp",
                droppingPoints[0]?.descp
              );
              setDropLatLng({
                lat: droppingPoints[0]?.lat,
                lng: droppingPoints[0]?.lng,
              });
              setDropCity(droppingPoints[0]?.title);
            }
            setIsLoading(false);
          } else {
            setIsLoading(false); // Disable loading if no data
          }
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        toast.dismiss();
        console.log(`Category  Error`, error);
        toast.error(
          error?.response?.data?.resDecrypt?.message ||
            error?.message ||
            "Something Went Wrong?"
        );
        setIsLoading(false);
      }
    }
  };

  const getCarsList = async () => {
    let apikey = sessionStorage.getItem("key");
    const userid = sessionStorage.getItem("userid");
    const city_id = sessionStorage.getItem("city_id");

    try {
      const response = await getCars(
        { driver_id: userid, city_id: city_id },
        // { city_id: 14 },
        apikey
      );
      ////console.log({ response });

      if (response.status === 200) {
        const newData = response?.data?.resDecrypt?.response;
        // console.log({newData})

        if (newData && newData.length > 0) {
          setCars(newData);
        }
      }
    } catch (error) {
      console.log(`Category  Error`, error);
    }
  };

  const getCategoryTagsList = async () => {
    let apikey = sessionStorage.getItem("key");

    try {
      const response = await getCategoryTags({}, apikey);
      ////console.log({ response });

      if (response.status === 200) {
        const newData = response?.data?.resDecrypt?.response;

        if (newData && newData.length > 0) {
          setCategoryTags(newData);
        }
      }
    } catch (error) {
      console.log(`Category  Error`, error);
    }
  };

  const getCategoryStopsData = async (from, to) => {
    let apikey = sessionStorage.getItem("key");
    //const userid = sessionStorage.getItem("userid");

    if (from && to) {
      try {
        const response = await getCategoryStopOvers(
          {
            from_location: from,
            to_location: to,
          },
          apikey
        );
        ////console.log({ response });

        if (response.status === 200) {
          const newData = response?.data?.response;

          if (newData && newData.length > 0) {
            const uniqueStops = [
  ...new Set(newData?.flatMap((value) => value?.cat_stopover || []))
];
            setItems(
              uniqueStops
            );
          }else{
            setItems([])
          }
        }
      } catch (error) {
        console.log(`Category  Error`, error);
        setItems([])
        // toast.error(error?.response?.data?.resDecrypt?.message || error?.message || 'Something Went Wrong?');
      }
    }
  };

  const handleFormviewChange = async (val) => {
    // const viewCheck = formView + val;
    // if (viewCheck <= 0) {
    //   setFormView(0);
    //   return;
    // }
    // setFormView((prev) => prev + val);
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      if (formView + val == 2) {
        await formik.submitForm();
      } else {
        setFormView((prev) => prev + val);
      }
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
        false
      );
    }
  };

  const handleFormViewBack = (val) => {
    const viewCheck = formView - val;
    if (viewCheck < 0) {
      setFormView(0);
      try {
        if (window.AndroidFunction) {
          console.log("Android");
          window.AndroidFunction.postMessage("Finish");
        } else {
          console.log("No Interface available");
        }

        const eventDetail = { message: "Finish", timestamp: Date.now() };
        // Create and dispatch the event
        const event = new CustomEvent("iosCustomEvent", {
          detail: eventDetail,
        });
        document.dispatchEvent(event);
        console.log("Custom event dispatched", eventDetail);
      } catch (error) {
        console.log(`No Interface available Err`, error);
      }
      return;
    }
    setFormView((prev) => prev - val);
  };

  const handleSortCity = (value) => {
    return value.sort((a, b) => a.name.localeCompare(b.name));
  };
  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return handleSortCity(citiesJson).filter((city) => {
      if (seen.has(city.name)) return false;
      seen.add(city.name);
      return true;
    });
  }, [citiesJson]);

  const incrementSeat = (step) => {
    //// console.log({ step }, parseInt(formik.values.cat_max_size) + step);
    formik.setFieldValue(
      "cat_max_size",
      parseInt(!formik.values.cat_max_size ? 0 : formik.values.cat_max_size) +
        step
    );
  };

  const decrementSeat = (step) => {
    //// console.log({ step }, parseInt(formik.values.cat_max_size) - step);
    formik.setFieldValue(
      "cat_max_size",
      parseInt(formik.values.cat_max_size) - step
    );
  };

  const incrementPrice = (step) => {
    if(parseInt(
      !formik.values.cat_base_price ? 190 : formik.values.cat_base_price
    ) + step > 10000){
      formik.setFieldValue(
        "cat_base_price",
        10000
      );
      return 
    }
    formik.setFieldValue(
      "cat_base_price",
      parseInt(
        !formik.values.cat_base_price ? 190 : formik.values.cat_base_price
      ) + step
    );
  };

  const decrementPrice = (step) => {
    formik.setFieldValue(
      "cat_base_price",
      parseInt(formik.values.cat_base_price) - step <= 10 ? 10 : parseInt(formik.values.cat_base_price) - step
    );
  };

  return (
    <section className="post_ride_form_mobile_container">
      <aside
        className="post_ride_form_mobile_container_close"
        onClick={() => {
          handleFormViewBack(1);
        }}
      >
        <i className="fas fa-arrow-left"></i>
        <Typography
          variant="h4"
          className="post_ride_heading"
          gutterBottom
          sx={{ textAlign: "center" }}
        >
          Post A Ride
        </Typography>
        {/* <div className="post_ride_form_mobile_container_heading">
          <Typography
          variant="h4"
          className="post_ride_heading"
          gutterBottom
          sx={{ textAlign: "center" }}
        >
          Post A Ride
        </Typography>
        <Typography
          variant="h6"
          className="post_ride_sub_heading"
          gutterBottom
          sx={{ textAlign: "center" }}
        >
         We are Currently available on route - Delhi - Jaipur - Delhi.
        </Typography>
        </div> */}
      </aside>
      {isLoading && <Loader classValue="loader_container_main" />}
      {formView == 0 && (
        <>
          <Typography
            variant="h6"
            mt={2}
            mb={2}
            className="post_ride_heading_title post_ride_form_mobile_container_title"
          >
            Select Locations
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={uniqueCities}
                getOptionLabel={(option) => {
                  return option.name ?? "";
                }}
                value={
                  uniqueCities.find(
                    (city) => city.name === formik.values.start_location
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue(
                    "start_location",
                    newValue?.name || null
                  );
                }}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option.name.toLowerCase().includes(inputValue.toLowerCase()?.trim())
                  )
                }
                renderInput={(params) => (
                  <TextField
                    key={params.id}
                    {...params}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="From"
                    placeholder="Enter From Location"
                    error={
                      formik.touched.start_location &&
                      Boolean(formik.errors.start_location)
                    }
                    helperText={
                      formik.touched.start_location &&
                      formik.errors.start_location
                    }
                  />
                )}
                isOptionEqualToValue={(option, value) => {
                  // console.log({option},value)
                  return option.name === value;
                }}
              />

              {formik.touched.start_location &&
                formik.errors.start_location && (
                  <Typography color="error" variant="caption">
                    {formik.errors.start_location}
                  </Typography>
                )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={uniqueCities}
                getOptionLabel={(option) => {
                  return option.name ?? "";
                }}
                value={
                  uniqueCities.find(
                    (city) => city.name === formik.values.end_location
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue("end_location", newValue?.name || null);
                }}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option.name.toLowerCase().includes(inputValue.toLowerCase()?.trim())
                  )
                }
                renderInput={(params) => (
                  <TextField
                    key={params.id}
                    {...params}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="To"
                    placeholder="Enter To Location"
                    error={
                      formik.touched.end_location &&
                      Boolean(formik.errors.end_location)
                    }
                    helperText={
                      formik.touched.end_location && formik.errors.end_location
                    }
                  />
                )}
                isOptionEqualToValue={(option, value) => {
                  return option.name === value;
                }}
              />

              {formik.touched.end_location && formik.errors.end_location && (
                <Typography color="error" variant="caption">
                  {formik.errors.end_location}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title"
                name="cat_name"
                value={formik.values.cat_name}
                InputLabelProps={{ shrink: true }}
                onChange={formik.handleChange}
                error={
                  formik.touched.cat_name && Boolean(formik.errors.cat_name)
                }
                helperText={formik.touched.cat_name && formik.errors.cat_name}
                placeholder="Enter Category Name"
              />
              {formik.touched.cat_name && formik.errors.cat_name && (
                <Typography color="error" variant="caption">
                  {formik.errors.cat_name}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <PlacesAutocomplete
                value={formik.values.pickup}
                onChange={(val) => formik.setFieldValue("pickup", val)}
                onSelect={(val, placeId) =>
                  handlePlaceSelect(val, placeId, "start_location_title")
                }
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                  <div style={{ position: "relative" }}>
                    <TextField
                      fullWidth
                      label="Boarding Points"
                      // {...getInputProps()}
                      {...getInputProps({
                        onFocus: () => {
                          setTimeout(() => {
                            document
                              .getElementById("boarding_point_container")
                              ?.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                              });
                          }, 300); // slight delay to wait for keyboard to show
                        },
                      })}
                      InputLabelProps={{ shrink: true }}
                      error={
                        formik.touched.pickup && Boolean(formik.errors.pickup)
                      }
                      helperText={formik.touched.pickup && formik.errors.pickup}
                      placeholder="Enter Boarding points"
                      InputProps={{
                        endAdornment: formik.values.start_location_title && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                formik.setFieldValue(
                                  "start_location_title",
                                  ""
                                );
                                formik.setFieldValue("pickup", "");
                              }}
                              size="small"
                            >
                              <i className="fas fa-times" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        zIndex: 1300,
                        backgroundColor: "#fff",
                        border:
                          suggestions?.length > 0 ? "1px solid #ccc" : "none",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        maxHeight: "300px",
                        overflowY: "scroll",
                      }}
                    >
                      {suggestions.map((sug) => (
                        <Box
                          key={sug.placeId}
                          {...extractSuggestionProps(
                            getSuggestionItemProps(sug)
                          )}
                          sx={{
                            p: 1,
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <i className="fas fa-map-marker-alt"></i>{" "}
                          {sug.description}
                        </Box>
                      ))}
                    </Box>
                  </div>
                )}
              </PlacesAutocomplete>
              {formik.touched.pickup && formik.errors.pickup && (
                <Typography color="error" variant="caption">
                  {formik.errors.pickup}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <PlacesAutocomplete
                value={formik.values.drop}
                onChange={(val) => formik.setFieldValue("drop", val)}
                onSelect={(val, placeId) =>
                  handlePlaceSelect(val, placeId, "end_location_title")
                }
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                  <div style={{ position: "relative" }}>
                    <TextField
                      fullWidth
                      label="Dropping Points"
                      // {...getInputProps()}

                      {...getInputProps({
                        onFocus: () => {
                          setTimeout(() => {
                            document
                              .getElementById("dropping_point_container")
                              ?.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                              });
                          }, 300); // slight delay to wait for keyboard to show
                        },
                      })}
                      InputLabelProps={{ shrink: true }}
                      error={formik.touched.drop && Boolean(formik.errors.drop)}
                      helperText={formik.touched.drop && formik.errors.drop}
                      placeholder="Enter Dropping Points"
                      InputProps={{
                        endAdornment: formik.values.end_location_title && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                formik.setFieldValue("end_location_title", "");
                                formik.setFieldValue("drop", "");
                              }}
                              size="small"
                            >
                              <i className="fas fa-times" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        zIndex: 1300,
                        backgroundColor: "#fff",
                        border:
                          suggestions?.length > 0 ? "1px solid #ccc" : "none",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        maxHeight: "300px",
                        overflowY: "scroll",
                      }}
                    >
                      {suggestions.map((sug) => (
                        <Box
                          key={sug.placeId}
                          {...extractSuggestionProps(
                            getSuggestionItemProps(sug)
                          )}
                          sx={{
                            p: 1,
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <i className="fas fa-map-marker-alt"></i>{" "}
                          {sug.description}
                        </Box>
                      ))}
                    </Box>
                  </div>
                )}
              </PlacesAutocomplete>
              {formik.touched.drop && formik.errors.drop && (
                <Typography color="error" variant="caption">
                  {formik.errors.drop}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Typography
            variant="h6"
            mt={2}
            mb={2}
            className="post_ride_heading_title post_ride_form_mobile_container_title"
          >
            Add stopovers
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              {items.length > 0 && (
                <List
              className="post_ride_stop_list"
                  sx={
                    items?.length > 4
                      ? { mb: 2, height: "50vh", overflowY: "scroll" }
                      : { mb: 2 }
                  }
                >
                  {items.map((item) => (
                    <ListItem
                      key={item}
                      dense
                      button
                      onClick={() => handleToggle(item)}
                      sx={{ display: "flex", alignItems: "center" }}
                      className={`post_ride_stop_list_item ${selectedItems.includes(item) ? "post_ride_stop_list_item_checked" : ""}`}
                    >
                      <Checkbox
                        edge="start"
                        checked={selectedItems.includes(item)}
                        tabIndex={-1}
                        disableRipple
                        className="post_ride_stop_list_checkbox"
                      />
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              )}
              <Box className="post_ride_add_stops_form">
                <TextField
                  label="New Stop"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={newItem}
                  onChange={handleChange}
                  fullWidth
                  className="post_ride_stop_input"
                  placeholder="Enter new stop"
                  id="post_ride_stop_input"
                />
                <button
                  type="button"
                  onClick={handleAddItem}
                  className="post_ride_button common_booking_button common_button_border"
                >
                  Add
                </button>
              </Box>

              {error && (
                <Typography color="error" variant="caption">
                  {error}
                </Typography>
              )}
            </Grid>
          </Grid>
        </>
      )}
      {formView == 1 && (
        <>
          <Typography
            variant="h6"
            mt={2}
            mb={2}
            className="post_ride_heading_title post_ride_form_mobile_container_title"
          >
            Select Dates
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  value={formik.values.departure_date}
                  minDate={dayjs().add(1, "hour")}
                  minTime={dayjs().add(1, "hour")}
                  disablePast
                  ampm
                  onChange={(e) => {
                    const departureTime = dayjs(e);
                    formik.setFieldValue("departure_date", e);

                    formik.setFieldValue(
                      "arrival_date",
                      dayjs(departureTime).add(1, "hour")
                    );
                  }}
                  format="YYYY-MM-DD hh:mm A"
                  label="Departure Date"
                  slotProps={{
                    textField: {
                      error: false,
                      // inputProps: {
                      //   disabled: true,
                      // },
                    },
                  }}
                />
              </LocalizationProvider>
              {formik.touched.departure_date &&
                formik.errors.departure_date && (
                  <Typography color="error" variant="caption">
                    {formik.errors.departure_date}
                  </Typography>
                )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  value={formik.values.arrival_date}
                  minDate={formik.values.departure_date}
                  minTime={formik.values.departure_date}
                  disablePast
                  ampm
                  onChange={(e) => {
                    const arrivalTime = e;
                    const departureTime = formik.values.departure_date;
                    // console.log(
                    //   { arrivalTime, departureTime },
                    //   new Date(arrivalTime.$d) > new Date(departureTime.$d)
                    // );
                    if (new Date(arrivalTime.$d) > new Date(departureTime.$d)) {
                      formik.setFieldValue("arrival_date", e);
                    }
                  }}
                  format="YYYY-MM-DD hh:mm A"
                  label="Arrival Date"
                  slotProps={{
                    textField: {
                      error: false,
                      // inputProps: {
                      //   disabled: true,
                      // },
                    },
                  }}
                />
              </LocalizationProvider>
              {formik.touched.arrival_date && formik.errors.arrival_date && (
                <Typography color="error" variant="caption">
                  {formik.errors.arrival_date}
                </Typography>
              )}
            </Grid>
          </Grid>
          <section className="post_ride_form_mobile_container_seat_section">
            <Typography
              variant="h6"
              mt={2}
              mb={2}
              className="post_ride_heading_title post_ride_form_mobile_container_title"
            >
              Select Seats
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className="post_ride_form_mobile_container_seat">
                  <button
                    type="button"
                    onClick={() => {
                      decrementSeat(defaultValues.seatStep);
                    }}
                    disabled={
                      formik.values.cat_max_size <= defaultValues.minSeat
                    }
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  {/* <span>{formik.values.cat_max_size}</span> */}
                  <input
                    type="number"
                    name="cat_max_size"
                    value={formik.values.cat_max_size}
                    onChange={(e) => {
                      const newValue = parseInt(e.target.value, 10);
                      if (!isNaN(newValue)) {
                        if (
                          newValue >= defaultValues.minSeat &&
                          newValue <= defaultValues.maxSeat
                        ) {
                          formik.setFieldValue("cat_max_size", newValue);
                        }
                      } else {
                        formik.setFieldValue("cat_max_size", "");
                      }
                    }}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      if (!formik.values.cat_max_size) {
                        formik.setFieldValue(
                          "cat_max_size",
                          defaultValues.minSeat
                        );
                      }
                    }}
                    className="post_ride_form_mobile_container_button_seat_input_field"
                  />
                  <button
                    type="button"
                    onClick={() => {
                      incrementSeat(defaultValues.seatStep);
                    }}
                    disabled={
                      formik.values.cat_max_size == defaultValues.maxSeat
                    }
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>

                {formik.touched.cat_max_size && formik.errors.cat_max_size && (
                  <Typography color="error" variant="caption">
                    {formik.errors.cat_max_size}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Typography
              variant="h6"
              mt={2}
              mb={2}
              className="post_ride_heading_title post_ride_form_mobile_container_title"
            >
              Select Price
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className="post_ride_form_mobile_container_price">
                  <button
                    type="button"
                    onClick={() => {
                      decrementPrice(defaultValues.priceStep);
                    }}
                    disabled={
                      formik.values.cat_base_price <= defaultValues.minPrice || formik.values.cat_base_price <= 10
                    }
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  {/* <span> &#8377; {formik.values.cat_base_price}</span> */}
                  <div className="post_ride_form_mobile_container_price_input">
                    {/* <span>&#8377;</span> */}
                    <input
                      type="text"
                      name="cat_base_price"
                      value={`₹ ${formik.values.cat_base_price}`}
                      onChange={(e) => {
                        const newValue = parseInt(e.target.value.replace(/[^\d]/g, ''));
                        if (!isNaN(newValue)) {
                          if (
                            newValue >= defaultValues.minPrice &&
                            newValue <= defaultValues.maxPrice
                          ) {
                            formik.setFieldValue("cat_base_price", newValue);
                          }
                        } else {
                          formik.setFieldValue("cat_base_price", "");
                        }
                      }}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                        if (!formik.values.cat_base_price) {
                          formik.setFieldValue("cat_base_price", 200);
                        }
                      }}
                      className="post_ride_form_mobile_container_button_seat_input_field"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      incrementPrice(defaultValues.priceStep);
                    }}
                    disabled={
                      formik.values.cat_base_price == defaultValues.maxPrice
                    }
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>

                {formik.touched.cat_base_price &&
                  formik.errors.cat_base_price && (
                    <Typography color="error" variant="caption">
                      {formik.errors.cat_base_price}
                    </Typography>
                  )}
              </Grid>
            </Grid>
             {sessionStorage.getItem("company_id") &&
                        parseInt(sessionStorage.getItem("company_id")) > 1 && (
                          <>
                            <Typography
                              variant="h6"
                              mt={2}
                              mb={2}
                              className="post_ride_heading_title post_ride_form_mobile_container_title"
                            >
                              Select Tags
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12}>
                                <List
                                  className="post_ride_stop_list"
                                  sx={
                                    categoryTags?.length > 4
                                      ? { mb: 2, height: "30vh", overflowY: "scroll" }
                                      : { mb: 2 }
                                  }
                                >
                                  {categoryTags.map((item) => (
                                    <ListItem
                                      key={item.title}
                                      dense
                                      button
                                      onClick={() => handleTagsToggle(item.value)}
                                      sx={{ display: "flex", alignItems: "center" }}
                                      className={`post_ride_stop_list_item ${tags.includes(item.value) ? "post_ride_stop_list_item_checked" : ""}`}
                                    >
                                      <Checkbox
                                        edge="start"
                                        checked={tags.includes(item.value)}
                                        tabIndex={-1}
                                        disableRipple
                                        className="post_ride_stop_list_checkbox"
                                      />
                                      <ListItemText primary={item.title} />
                                    </ListItem>
                                  ))}
                                </List>
                              </Grid>
                            </Grid>
                          </>
                        )}
            <Typography
            variant="h6"
            mt={2}
            mb={2}
            className="post_ride_heading_title post_ride_form_mobile_container_title"
          >
            Select Vehicle
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <List
              className="post_ride_stop_list"
                sx={
                  cars?.length > 3
                    ? { mb: 2, height: "30vh", overflowY: "scroll" }
                    : { mb: 2 }
                }
              >
                {cars.map((item) => (
                  <ListItem
                    key={item?.car_id}
                    dense
                    button
                    onClick={() => handleCarToggle(item?.car_id)}
                    sx={{ display: "flex", alignItems: "center" }}
                    className={`post_ride_stop_list_item ${formik.values.car_id == item?.car_id ? "post_ride_stop_list_item_checked" : ""}`}
                  >
                    <Radio
                      edge="start"
                      checked={formik.values.car_id == item?.car_id}
                      tabIndex={-1}
                      disableRipple
                      className="post_ride_stop_list_checkbox"
                    />
                    <ListItemText
                      primary={`${item?.car_name}`}
                      secondary={item?.car_reg_no}
                    />
                  </ListItem>
                ))}
              </List>
              {formik.touched.car_id && formik.errors.car_id && (
                <Typography color="error" variant="caption">
                  {formik.errors.car_id}
                </Typography>
              )}
            </Grid>
          </Grid>
          </section>
        </>
      )}
      <Box mt={2} mb={2}>
        <button
          type="button"
          className="post_ride_mobile_button common_booking_button common_button_border"
          onClick={() => {
            handleFormviewChange(1);
          }}
        >
          Continue{" "}
          <i className="fas fa-arrow-circle-right" aria-hidden="true"></i>
        </button>        
      {/* <Typography
          variant="h6"
          className="post_ride_sub_heading"
          gutterBottom
        >
         * We are currently available on route - Delhi - Jaipur - Delhi.
        </Typography> */}
      </Box>
      <div id="dropping_point_container"></div>
      <div id="boarding_point_container"></div>
    </section>
  );
};

export default PostRideForm;
